"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixtureType = void 0;
var FixtureType;
(function (FixtureType) {
    FixtureType[FixtureType["Other"] = 0] = "Other";
    FixtureType[FixtureType["Faucet, Cold"] = 1] = "Faucet, Cold";
    FixtureType[FixtureType["Water Cooler"] = 2] = "Water Cooler";
    FixtureType[FixtureType["Drinking Water Fountain"] = 3] = "Drinking Water Fountain";
    FixtureType[FixtureType["Ice Machine"] = 4] = "Ice Machine";
    FixtureType[FixtureType["Kitchen Kettle, Cold"] = 5] = "Kitchen Kettle, Cold";
    FixtureType[FixtureType["Spigot"] = 6] = "Spigot";
    FixtureType[FixtureType["Service Line"] = 7] = "Service Line";
    FixtureType[FixtureType["Coffee Maker"] = 8] = "Coffee Maker";
    FixtureType[FixtureType["Kitchen Kettle, Hot"] = 9] = "Kitchen Kettle, Hot";
    FixtureType[FixtureType["Faucet, Hot"] = 10] = "Faucet, Hot";
    FixtureType[FixtureType["Sprayer"] = 11] = "Sprayer";
    FixtureType[FixtureType["Bubbler"] = 12] = "Bubbler";
    FixtureType[FixtureType["Bottle Filler"] = 13] = "Bottle Filler";
})(FixtureType = exports.FixtureType || (exports.FixtureType = {}));
//# sourceMappingURL=FixtureType.js.map